/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:30
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-13 15:57:55
 */
import request from "@/util/request";

// 交易项目分页列表
export function outProjectList(data) {
  return request({
    method: "post",
    url: "/api/outProjectList",
    data: data,
    params: data
  });
}

// // 交易项目分页列表
export function outProjectList1(data) {
  return request({
    method: "post",
    url: "/api/outProjectList",
    params: data,
    data: { keyword: data.keyword }
  });
}

// 获取产权类型列表
export function getProList(params) {
  return request({
    method: "post",
    url: "/api/propertyTypeList",
    params
  });
}
